import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableFooter,
  TableHead,
} from '@mui/material';
import { styled } from '@mui/material/styles';

interface StyledTableContainerProps {
  fullHeight?: boolean;
  marginBottom?: string | number;
}

const shouldForwardProp = (prop: PropertyKey) =>
  !['fullHeight', 'marginBottom', 'isLink'].includes(prop as string);

export const StyledTableContainer = styled(TableContainer, {
  shouldForwardProp,
})<StyledTableContainerProps>(({ theme, marginBottom }) => ({
  height: '100%',
  marginBottom,
  overflowX: 'auto',
  overflowY: 'hidden',
  borderTopLeftRadius: theme.spacing(1),
  borderTopRightRadius: theme.spacing(1),
  [theme.breakpoints.up('md')]: {
    overflowX: 'auto',
  },
  [theme.breakpoints.down('md')]: {
    overflowX: 'auto',
    overflowY: 'auto',
  },
}));

export const StyledTable = styled(Table)(({ theme }) => ({
  borderRadius: theme.spacing(2),
  border: `1px solid ${theme.palette.divider}`,
}));

export const StyledTableHead = styled(TableHead)(({ theme }) => ({
  backgroundColor: theme.palette.divider,
  borderRadius: theme.spacing(1),
}));

export const StyledTableBody = styled(TableBody)(({ theme }) => ({
  backgroundColor: theme.palette.common.white,
}));

export const StyledBoxContainer = styled(Box)(({ theme }) => ({
  width: '100%',
  display: 'flex',
  justifyContent: 'flex-end',
  backgroundColor: theme.palette.common.white,
  border: `1px solid ${theme.palette.divider}`,
  borderTop: 'none',
  borderBottomLeftRadius: theme.spacing(1),
  borderBottomRightRadius: theme.spacing(1),

  [theme.breakpoints.down('md')]: {
    justifyContent: 'center',
  },
}));

export const StyledTableFooter = styled(TableFooter)(({ theme }) => ({
  width: '100%',
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  backgroundColor: theme.palette.common.white,
}));

interface StyledTableCellProps {
  isLink?: boolean;
}

export const StyledTableCell = styled(TableCell, {
  shouldForwardProp,
})<StyledTableCellProps>(({ theme, isLink }) => ({
  // border: `1px solid ${theme.palette.divider}`,
  boxShadow: 'inset 0 -1px 0 0 rgba(0, 0, 0, 0.12)',
  ...(isLink && {
    cursor: 'pointer',
    color: theme.palette.info.main,
  }),
}));
